import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { updateCheckInOutApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const updateCheckInOut = createAsyncThunk('updateCheckInOut', async (payload) => {
  return await updateCheckInOutApi(payload);
});

const updateCheckInOutSlice = createSlice({
  name: 'updateCheckInOut', // Unique Name
  initialState,
  reducers: {
    updateCheckInOutReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateCheckInOut.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(updateCheckInOut.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(updateCheckInOut.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { updateCheckInOutReset } = updateCheckInOutSlice.actions;

export default updateCheckInOutSlice.reducer;
